













import Vue from 'vue';
import { QUOTA_AND_DEALS_MODAL_TITLE } from '~/components/partials/jobs/JobsProfile/constants';

export default Vue.extend({
  name: 'RadioButton',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md'].includes(value),
    },
    label: {
      type: String,
      default: '',
    },
    group: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(e: Event) {
      const el = e.target as HTMLInputElement;
      const { label, group, value } = this;
      this.$emit('change', { label, group, value, checked: el.checked });
    },
  },
});
